const FeeProviderFormTestIdsScope = {
  FEE_PROVIDER_FORM: 'fee-provider-form',
};

export const FeeProviderFormTestIds = {
  FEE_PROVIDER_FORM_CITY_INPUT: `${FeeProviderFormTestIdsScope.FEE_PROVIDER_FORM}.city-input`,
  FEE_PROVIDER_FORM_CONTACT_EMAIL_INPUT: `${FeeProviderFormTestIdsScope.FEE_PROVIDER_FORM}.contact-email-input`,
  FEE_PROVIDER_FORM_CONTACT_PERSON_INPUT: `${FeeProviderFormTestIdsScope.FEE_PROVIDER_FORM}.contact-person-input`,
  FEE_PROVIDER_FORM_CONTACT_PHONE_INPUT: `${FeeProviderFormTestIdsScope.FEE_PROVIDER_FORM}.contact-phone-input`,
  FEE_PROVIDER_FORM_EMAIL_INPUT: `${FeeProviderFormTestIdsScope.FEE_PROVIDER_FORM}.email-input`,
  FEE_PROVIDER_FORM_ADD_TO_SERVICE_PROVIDER_LIST_CHECKBOX: `${FeeProviderFormTestIdsScope.FEE_PROVIDER_FORM}.add-to-service-provider-list-checkbox`,
  FEE_PROVIDER_FORM_AFFILIATE_CHECKBOX: `${FeeProviderFormTestIdsScope.FEE_PROVIDER_FORM}.affiliate-checkbox`,
  FEE_PROVIDER_FORM: 'fee-provider.form',
  FEE_PROVIDER_FORM_CANCEL_BUTTON: `${FeeProviderFormTestIdsScope.FEE_PROVIDER_FORM}.cancel-button`,
  FEE_PROVIDER_FORM_LICENSE_NUMBER_INPUT: `${FeeProviderFormTestIdsScope.FEE_PROVIDER_FORM}.license-number-input`,
  FEE_PROVIDER_FORM_PAID_TO_TYPE_SELECT: `${FeeProviderFormTestIdsScope.FEE_PROVIDER_FORM}.paid-to-type-select`,
  FEE_PROVIDER_FORM_STATE_SELECT: `${FeeProviderFormTestIdsScope.FEE_PROVIDER_FORM}.state-select`,
  FEE_PROVIDER_FORM_SUBMIT_BUTTON: `${FeeProviderFormTestIdsScope.FEE_PROVIDER_FORM}.submit-button`,
  FEE_PROVIDER_FORM_NAME_INPUT: `${FeeProviderFormTestIdsScope.FEE_PROVIDER_FORM}.name-input`,
  FEE_PROVIDER_FORM_PHONE_INPUT: `${FeeProviderFormTestIdsScope.FEE_PROVIDER_FORM}.phone-input`,
  FEE_PROVIDER_FORM_STREET_ADDRESS_INPUT: `${FeeProviderFormTestIdsScope.FEE_PROVIDER_FORM}.street-address-input`,
  FEE_PROVIDER_FORM_SUITE_INPUT: `${FeeProviderFormTestIdsScope.FEE_PROVIDER_FORM}.suite-input`,
  FEE_PROVIDER_FORM_ZIP_CODE_INPUT: `${FeeProviderFormTestIdsScope.FEE_PROVIDER_FORM}.zip-code-input`,
};
